export { default } from "./MenuCreateProject";


// WEBPACK FOOTER //
// ./src/components/MenuCreateProject/index.js